module.exports = __webpack_public_path__ + "static/media/check-icon.7950641b.svg";